// add checkout globally accessible through window object
window.checkout = {
    chargebeeInvoiceIds: [],
    chargebeeSubscriptionIds: [],
    email: null,
    emailUserAccountExists: false,
    first_name: null,
    last_name: null,
    phone: null,
    marketing_opt_in: null,
    billing: {},
    shipping: {},
    shipToBillingAddress: true,
    errorMessage: null,

    hasProvidedEmail: function() {
        return this.email && this.email.length > 5;
    },
    getBillingAddress: function() {
        return {
            first_name: this.billing.first_name.trim(),
            last_name: this.billing.last_name.trim(),
            line1: this.billing.address.trim(),
            line2: this.billing.address2 ? this.billing.address2.trim() : null,
            city: this.billing.city.trim(),
            zip: this.billing.zip.trim(),
            state: this.billing.state.trim(),
            phone: (this.billing.phone && this.billing.phone.length > 8 ? this.billing.phone.trim() : this.phone.trim()),
            email: (this.billing.email && this.billing.email.length > 6 ? this.billing.email.trim() : this.email.trim()),
            country: this.billing.country.trim()
        };
    },
    getShippingAddress: function() {
        if (this.shipToBillingAddress) {
            return this.getBillingAddress();
        }

        return {
            first_name: this.shipping.first_name.trim(),
            last_name: this.shipping.last_name.trim(),
            line1: this.shipping.address.trim(),
            line2: this.shipping.address2 ? this.shipping.address2.trim() : null,
            city: this.shipping.city.trim(),
            zip: this.shipping.zip.trim(),
            state: this.shipping.state.trim(),
            phone: (this.shipping.phone && this.shipping.phone.length > 8 ? this.shipping.phone.trim() : this.phone.trim()),
            email: (this.shipping.email && this.shipping.email.length > 6 ? this.shipping.email.trim() : this.email.trim()),
            country: this.shipping.country.trim()
        };
    },
    doCheckout: async function(additionalParams) {
        try {
            // remove any existing errors and empty the order/subscription id arrays
            this.errorMessage = null;
            this.chargebeeInvoiceIds = [];
            this.chargebeeSubscriptionIds = [];
            const ga4Identifiers = await window.tracking.ga4.getIdentifiers();

            let customerDetails = {
                email: this.email,
                first_name: this.first_name,
                last_name: this.last_name,
                phone: this.phone,
                marketing_opt_in: this.marketing_opt_in,
            };

            if (window.customer.customer_id) {
                // if the customer has a CB ID then add it to the request
                customerDetails.id = window.customer.customer_id;
            }

            const responseJson = await window.utils.request.post(
                '/wp-json/klira/checkout/process',
                    {
                        customer: customerDetails,
                        billing_address: this.getBillingAddress(),
                        shipping_address: this.getShippingAddress(),
                        items: window.cart.buildLineItems(),
                        coupons: window.cart.buildCouponItems(),
                        ga4: ga4Identifiers,
                        ...additionalParams
                    }
                );

            if (typeof responseJson === 'object') {
                // if it's an object then we have an error.
                this.errorMessage = "Could not process checkout, please try again once the page has refreshed";
                window.location.reload();
                return false;
            }

            let responseObj = JSON.parse(responseJson);

            if (!responseObj.success) {
                if (responseObj.message) {
                    // add the error message, so we can display to the user
                    this.errorMessage = responseObj.message;
                }

                if (responseObj.hasBeenLoggedIn) {
                    // we failed to check out, but they were logged in, refresh, so we get a new nonce
                    this.save();
                    window.location.reload();
                }

                return false;
            }

            if (responseObj.subscriptions) {
                // populate the subscription ID array
                responseObj.subscriptions.forEach(function (subscriptionId) {
                    window.checkout.chargebeeSubscriptionIds.push(subscriptionId);
                });
            }

            if (responseObj.charges) {
                // populate the invoice ID array
                responseObj.charges.forEach(function (invoiceId) {
                    window.checkout.chargebeeInvoiceIds.push(invoiceId);
                });
            }

            // Push the GTM 'purchase' event now, at confirmation, so it fires even if the
            // browser never fully loads /thank-you. Then tell the server we've tracked it so
            // the thank-you page stays a true fallback (fires only if this push never ran) —
            // this prevents a double push for tags that don't dedupe on transaction_id (e.g. VWO).
            if (responseObj.ecommerce) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push({
                    'event'    : 'purchase',
                    'user_id'  : responseObj.user_id,
                    'ecommerce': responseObj.ecommerce
                });

                // clear the stored fallback payload so /thank-you doesn't push it again
                try {
                    await window.utils.request.post('/wp-json/klira/checkout/purchase-tracked', {});
                } catch (e) {
                    console.log('CHECKOUT: Could not clear purchase fallback', e);
                }
            }

            // redirect
            window.location.href = '/thank-you/'
        } catch (error) {
            console.log(error);
            return false
        }

        return true;
    },

    // persist methods
    clear: function() {
        console.log('CHECKOUT: Clearing data');
        this.email = null;
        this.emailUserAccountExists = false;
        this.first_name = null;
        this.last_name = null;
        this.phone = null;
        this.billing = {};
        this.shipping = {};
        this.chargebeeInvoiceIds = null;
        this.chargebeeSubscriptionIds = null;
        this.shipToBillingAddress = true;
        this.marketing_opt_in = null;

        localStorage.removeItem('checkout/details');
    },
    save: function() {
        console.log('CHECKOUT: Saving');
        localStorage.setItem('checkout/details', JSON.stringify(this));
    },
    load: function() {
        this.loadFromCustomer();

        if (!localStorage.getItem('checkout/details')) {
            return;
        }

        console.log('CHECKOUT: Loading');
        window.checkout = {...this, ...JSON.parse(localStorage.getItem('checkout/details'))};
    },
    loadFromCustomer: function() {
        this.email = window.customer.email || null;
        this.first_name = window.customer.first_name || null;
        this.last_name = window.customer.last_name || null;
        this.phone = window.customer.phone || window.customer.addresses.billing?.phone || window.customer.addresses.shipping?.phone;

        if (Object.keys(this.billing).length === 0) {
            this.billing = window.customer.addresses.billing;
        }

        if (Object.keys(this.shipping).length === 0) {
            this.shipping = window.customer.addresses.shipping;
        }
    }
}

// load the checkout details immediately
window.checkout.load();
